import axios from 'axios';
import { BACKEND_URL } from '../../config';

const BASE = `${BACKEND_URL}/api/admin/family/accounts`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
  return e?.message || 'Something went wrong';
};

export const familyApi = {
  list: () => axios.get(BASE).then((r) => r.data),
  create: (body) => axios.post(BASE, body).then((r) => r.data.account),
  update: (id, body) => axios.patch(`${BASE}/${id}`, body).then((r) => r.data.account),
  action: (id, name, body) => axios.post(`${BASE}/${id}/${name}`, body || {}).then((r) => r.data.account),
  remove: (id) => axios.delete(`${BASE}/${id}`).then((r) => r.data),
  me: () => axios.get(`${BACKEND_URL}/api/family-access/me`).then((r) => r.data),
};

export const todayAdelaide = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Adelaide' }).format(new Date());

export const toISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const fromISO = (s) => {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const fmtDay = (s) =>
  s ? fromISO(s).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString('en-AU', { timeZone: 'Australia/Adelaide', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'Never';

export const daysBetween = (a, b) => {
  const out = [];
  let [s, e] = a <= b ? [a, b] : [b, a];
  const d = fromISO(s);
  const end = fromISO(e);
  while (d <= end) {
    out.push(toISO(d));
    d.setDate(d.getDate() + 1);
  }
  return out;
};

export const periodsOf = (dates) => {
  const sorted = [...new Set(dates)].sort();
  const runs = [];
  sorted.forEach((s) => {
    const last = runs[runs.length - 1];
    if (last) {
      const n = fromISO(last.end);
      n.setDate(n.getDate() + 1);
      if (toISO(n) === s) { last.end = s; last.count += 1; return; }
    }
    runs.push({ start: s, end: s, count: 1 });
  });
  return runs;
};
